import '../constants/login.js';
import '../constants/activity.js';
import '../constants/common.js';
import { LANG_LOCAL_STORAGE_KEY, ZH, EN } from '../constants/locale.js';

const TRANS_MAP = {
    '参会码发送失败，请检查电话号码和邮件地址是否填写正确并重试': 'Please check if the phone number and email address are filled in correctly and try again.',
    '激活邮件发送失败，请稍后重新尝试': 'Failed to send activation email, please try again later',
    用户名或密码错误: 'Incorrect username or password',
};
const getTransErrorMsg = (errMsg, lang) => {
    const _language = lang || localStorage.getItem(LANG_LOCAL_STORAGE_KEY) || ZH;
    if (_language === EN) {
        return TRANS_MAP[errMsg] || errMsg;
    }
    else {
        return errMsg;
    }
};

export { getTransErrorMsg };
